module.exports = __webpack_public_path__ + "img/MercerMarsh.a7d47187.png";